<script setup lang="ts">
import { $inj, $injByInterface } from "@/common/decorators/depinject";
import { WorkflowStatesConstant } from "@/common/constant/WorkflowStatesConstant";
import { ErrorHandler } from "@/open/handlers/ErrorHandler";
import OpenAuthFactory from "@/open/app/factories/authorization/OpenAuthFactory";
import type IRouterService from "@/common/services/utils/IRouterService";
import { useRoute } from "vue-router";
import { onErrorCaptured } from "vue";
try {
  const openAuthFactory = $inj(OpenAuthFactory);
  const routerService = $injByInterface<IRouterService>("IRouterService");
  await openAuthFactory.authorize();

  routerService.push({
    name:
      routerService.currentRoute.value.name === WorkflowStatesConstant.ENTRY.STATE
        ? WorkflowStatesConstant.START_PERSON.STATE
        : routerService.currentRoute.value.name || "",
    params: routerService.currentRoute.value.params,
    query: routerService.currentRoute.value.query
  });
} catch (error) {
  ErrorHandler.handle(error);
}
onErrorCaptured((err) => {
  //note: an error "OPEN_NOT_AUTHORIZED" is expected when Tracker() called.
  //This happens when you reload the URL in browser "/workflow/workspaceUUID?trackerUUID"
  //In this case we redirect either to continue or error page
  const route = useRoute();
  const workspaceUUID = route.params.workspaceUUID as string;
  const trackerUUID = route.query.trackerUUID as string;
  ErrorHandler.handleNavigationErrorForWorkspace(workspaceUUID, trackerUUID);
  const bubbleUpErrorToGlobalHandler = false;
  return bubbleUpErrorToGlobalHandler;
});
</script>

<template>
  <router-view> </router-view>
</template>
